export default function validateDiscordName(discordName: string): boolean {
  if (discordName.length === 0) return false;
  if (discordName === "") return false;
  if (!discordName.includes("#")) return false;
  if (discordName.split("#")[1].length === 0) return false;
  return true;
}
